import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新文章
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              使用指南、漫画推荐、平台资讯持续更新中
            </p>
          </div>
          <Link
            to="/category/hot"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:bg-background-200/30"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hot"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}